import { DEFAULT_BRANDING } from '../../redux/slices/branding/brandingSlice';
import { buildBrandPalette } from './brandColorPalette';

const BRAND_CSS_VARS = {
  '--primary-Color': 'primary',
  '--primary-Color-Opacity': 'opacity',
  '--primary-Color-light': 'light',
  '--primary-Color-soft': 'soft',
  '--primary-Color-deep': 'deep',
  '--primary-Color-complement': 'complement',
  '--primary-Color-complement-soft': 'complementSoft',
  '--primary-Color-foreground': 'foreground',
  '--primary-Color-foreground-dark': 'foregroundDark',
};

export const applyBrandingCss = (primaryColor = DEFAULT_BRANDING.primaryColor) => {
  const palette = buildBrandPalette(primaryColor || DEFAULT_BRANDING.primaryColor);

  if (!palette) return;

  Object.entries(BRAND_CSS_VARS).forEach(([cssVar, paletteKey]) => {
    document.documentElement.style.setProperty(cssVar, palette[paletteKey]);
  });
};
